import { companyInfo } from "./companyInfo";

export const termsOfService = {
  ...companyInfo,
  lastUpdated: companyInfo.tos.lastUpdated,

  sections: [
    {
      id: "acceptance",
      title: "1. Acceptance of Terms",
      content: [
        "By accessing or using the WaBM Partner Dashboard (the 'Dashboard'), you acknowledge that you have read, understood, and agree to be bound by these Terms of Service (the 'Terms') and our Privacy Policy.",
        "These Terms constitute a legally binding agreement between you (the 'Partner') and WaBM Technologies Pvt. Ltd. ('WaBM', 'we', 'us', or 'our'). If you do not agree to these Terms, you must not access or use the Dashboard.",
        "We reserve the right to update or modify these Terms at any time. Continued use of the Dashboard after such changes constitutes your acceptance of the updated Terms.",
      ],
    },
    {
      id: "partner-eligibility",
      title: "2. Partner Eligibility & Onboarding",
      content: [
        "Access to the WaBM Partner Dashboard is granted exclusively to individuals or entities who have entered into a valid Partner Agreement with WaBM Technologies Pvt. Ltd.",
        "You must be at least 18 years of age and have the legal authority to enter into this agreement on behalf of yourself or your organization.",
        "Partner credentials (Corporate ID, Agent ID, and Password) are issued by WaBM upon successful onboarding. Sharing credentials with unauthorized personnel is strictly prohibited.",
        "WaBM reserves the right to suspend or terminate Partner access at any time if eligibility requirements are no longer met or if a violation of these Terms is detected.",
      ],
    },
    {
      id: "account-security",
      title: "3. Account Security & Responsibilities",
      content: [
        "You are solely responsible for maintaining the confidentiality of your login credentials (Corporate ID, Agent ID, and Password). You must not disclose these credentials to any third party.",
        "You agree to notify WaBM immediately at partners@wabm.in if you suspect any unauthorized access to your account or any other security breach.",
        "WaBM will not be liable for any loss or damage arising from your failure to comply with these security obligations.",
        "You agree not to attempt to bypass, disable, or circumvent any authentication, security, or access control mechanisms of the Dashboard.",
      ],
    },
    {
      id: "permitted-use",
      title: "4. Permitted Use of the Dashboard",
      content: [
        "The Dashboard is provided for the sole purpose of managing your assigned WaBM client accounts, monitoring usage, reviewing analytics, and performing legitimate partner operations.",
        "You may use the Dashboard only for lawful purposes and in accordance with these Terms. You agree not to use the Dashboard in any way that violates applicable local, national, or international laws or regulations.",
        "Permitted activities include: managing registered users, viewing recharge histories, reviewing campaign analytics, configuring pricing, and accessing integrations on behalf of your clients.",
        "Any use of the Dashboard to access, extract, or export data beyond your authorized scope is strictly prohibited.",
      ],
    },
    {
      id: "prohibited-activities",
      title: "5. Prohibited Activities",
      content: [
        "You must not use the Dashboard to engage in any activity that is unlawful, harmful, fraudulent, deceptive, threatening, abusive, harassing, defamatory, or otherwise objectionable.",
        "You must not attempt to gain unauthorized access to any part of the Dashboard, server, network, or database connected to the Dashboard.",
        "You must not use automated bots, scrapers, crawlers, or similar tools to extract data from the Dashboard without prior written consent from WaBM.",
        "You must not misrepresent your identity, affiliation, or authority while using the Dashboard.",
        "You must not engage in any activity that disrupts, interferes with, or imposes an unreasonable load on the Dashboard infrastructure.",
      ],
    },
    {
      id: "data-confidentiality",
      title: "6. Data Confidentiality & Client Data",
      content: [
        "As a Partner, you may have access to sensitive information about WaBM end-clients, including business details, usage data, WhatsApp Business API credentials, and financial records.",
        "You agree to treat all client data as strictly confidential. You must not disclose, sell, rent, transfer, or otherwise make available such data to any third party without prior written consent from the respective client and WaBM.",
        "You are responsible for complying with all applicable data protection and privacy laws, including but not limited to the Information Technology Act, 2000 (India) and applicable GDPR regulations where relevant.",
        "Upon termination of your Partner Agreement, you must immediately cease access to and delete all client data in your possession that was obtained through the Dashboard.",
      ],
    },
    {
      id: "intellectual-property",
      title: "7. Intellectual Property",
      content: [
        "The WaBM Partner Dashboard, including all software, design, content, trademarks, logos, and proprietary technology, is owned by WaBM Technologies Pvt. Ltd. and is protected by applicable intellectual property laws.",
        "Nothing in these Terms transfers any intellectual property rights to you. You are granted a limited, non-exclusive, non-transferable, revocable license to use the Dashboard solely for the purposes described in these Terms.",
        "You must not copy, modify, distribute, sell, sublicense, reverse-engineer, or create derivative works based on the Dashboard or any of its components without prior written consent from WaBM.",
      ],
    },
    {
      id: "service-availability",
      title: "8. Service Availability & Maintenance",
      content: [
        "WaBM endeavors to maintain Dashboard availability at all times but does not guarantee uninterrupted or error-free access. The Dashboard may be temporarily unavailable due to scheduled maintenance, upgrades, or unforeseen technical issues.",
        "WaBM reserves the right to modify, suspend, or discontinue any feature or functionality of the Dashboard at any time with or without notice.",
        "WaBM shall not be liable to you or any third party for any modification, suspension, or discontinuation of the Dashboard or any part thereof.",
      ],
    },
    {
      id: "limitation-of-liability",
      title: "9. Limitation of Liability",
      content: [
        "To the maximum extent permitted by applicable law, WaBM Technologies Pvt. Ltd., its directors, employees, partners, agents, suppliers, or affiliates, shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, goodwill, or other intangible losses resulting from your use of or inability to use the Dashboard.",
        "WaBM's total liability to you for any claim arising out of or relating to these Terms or the Dashboard shall not exceed the fees paid by you to WaBM in the six (6) months preceding the claim.",
        "Some jurisdictions do not allow the exclusion of certain warranties or limitation of liability, so some of the above limitations may not apply to you.",
      ],
    },
    {
      id: "termination",
      title: "10. Termination",
      content: [
        "WaBM may terminate or suspend your access to the Dashboard immediately, without prior notice or liability, for any reason, including if you breach these Terms.",
        "You may terminate your use of the Dashboard at any time by contacting your WaBM account manager or emailing partners@wabm.in.",
        "Upon termination, your right to use the Dashboard will immediately cease. All provisions of these Terms which by their nature should survive termination shall survive, including ownership provisions, warranty disclaimers, indemnity, and limitations of liability.",
      ],
    },
    {
      id: "governing-law",
      title: "11. Governing Law & Dispute Resolution",
      content: [
        "These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.",
        "Any dispute arising out of or in connection with these Terms, including any question regarding their existence, validity, or termination, shall be subject to the exclusive jurisdiction of the courts located in New Delhi, India.",
        "Before resorting to formal legal proceedings, both parties agree to attempt to resolve any dispute informally by contacting WaBM at partners@wabm.in for a period of thirty (30) days.",
      ],
    },
    {
      id: "contact",
      title: "12. Contact Information",
      content: [
        "If you have any questions, concerns, or feedback regarding these Terms of Service, please contact us:",
        "Email: partners@wabm.in",
        "Address: WaBM Technologies Pvt. Ltd., New Delhi, India",
        "We aim to respond to all partner queries within 2 to 3 business days.",
      ],
    },
  ],
};
